'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reducer;
exports.meetingEnded = meetingEnded;
exports.addUser = addUser;
exports.addParticipant = addParticipant;
exports.updateParticipant = updateParticipant;
exports.setCurrentMeeting = setCurrentMeeting;
exports.addChatMessage = addChatMessage;
exports.addChat = addChat;
exports.removeChat = removeChat;
exports.userJoin = userJoin;
exports.userLeave = userLeave;
exports.userStartTypingMessage = userStartTypingMessage;
exports.updateDisplayMode = updateDisplayMode;
exports.updateTypingMessage = updateTypingMessage;
exports.updateLastTypedMessage = updateLastTypedMessage;
exports.updateUnreadMessagecount = updateUnreadMessagecount;
exports.loadHistoryMessages = loadHistoryMessages;
exports.loadParticipants = loadParticipants;

var _helpers = require('../common/helpers');

var Helpers = _interopRequireWildcard(_helpers);

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// import {jmclient} from '../../../jmclient/lib'


var CHAT_ADD_MESSAGE = "chat-add-message";
var CHAT_ADD = "chat-add";
var CHAT_REMOVE = "chat-remove";
var CHAT_USER_JOIN = "chat-user-join";
var CHAT_USER_LEAVE = "chat-user-leave";
var CHAT_USER_STATUS_CHANGE = "chat-user-status-change";
var CHAT_SET_CURRENT_MEETING = "chat-set-current-meeting";
var CHAT_USER_START_TYPING = "chat-user-start-typing";
var CHAT_ADD_USER = "chat-add-user";
var CHAT_ADD_PARTICIPANT = "chat-add-participant";
var CHAT_UPDATE_PARTICIPANT_LIST = "chat-update-participant-list";
var CHAT_DISPLAY_MODE_UPDATE = "chat-window-state-update";
var CHAT_TYPING_MESSAGE_UPDATE = "chat-typing-message-update";
var CHAT_LAST_TYPED_MESSAGE_UPDATE = "chat-last-typed-message-update";
var CHAT_UNREAD_MESSAGES = "chat-unread-messages";
var CHAT_ENDED = 'chat-ended';

// const CREATE_MEETING_REQUEST_START = "create-meeting-request-start"
// const CREATE_MEETING_REQUEST_SUCCESS = "create-meeting-request-success"
// const CREATE_MEETING_REQUEST_FAIL = "create-meeting-request-fail"
var LOAD_HISTORY_MESSAGES_SUCCESS = "load-history-messages-success";
var LOAD_HISTORY_MESSAGES_FAIL = "load-history-messages-fail";
var MESSAGE_RETAIN_COUNT = 1024;

// SCHEMA(user) = Object({id:-1, name:"unknown", email:"unknown@na.com", status:"unknown", online:false})
// SCHEMA(chats - to hold chat objects) {
// SCHEMA(chat - represent individual chat (group/one-to-one)) = {
//     type: "group" | "one-to-one"
//     messages:[],
//     participants:[] // collection of user object,
// } 
// SCHEMA(currentMeeting) - hold current active chat object 
//
var initialUserState = { id: -1, name: "unknown", email: "unknown@na.com", status: "unknown", online: false };
var initialState = { user: initialUserState, chats: [], currentMeeting: {} };
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];


    var newState = initialState;
    var chats = void 0,
        chat = void 0,
        meetingId = void 0,
        currentMeeting = void 0,
        chatIndex = void 0;

    switch (action.type) {
        case CHAT_USER_START_TYPING:
            meetingId = action.payload.data.meeting_id;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            // chatIndex = state.chats.map(function(chat) { return chat.meetingId; }).indexOf(action.payload)
            chat = state.chats[chatIndex];
            chat = Object.assign({}, chat);
            if (!chat.userTypingProperties) chat.userTypingProperties = [];

            chat.userTypingProperties[action.payload.data.sender_id] = action.payload.data;
            chat.userTypingProperties[action.payload.data.sender_id].message_id = action.payload.message_id;

            state.chats[chatIndex] = chat;

            newState = Object.assign({}, state);
            break;

        case CHAT_TYPING_MESSAGE_UPDATE:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            // chatIndex = state.chats.map(function(chat) { return chat.meetingId; }).indexOf(action.payload)
            chat = state.chats[chatIndex];
            chat = Object.assign({}, chat);
            console.log("action payload...: ", action.payload);
            console.log("chat usert tping properties array ... : ", chat.userTypingProperties);
            chat.userTypingProperties[action.payload.sender_id].message = action.payload.message;

            state.chats[chatIndex] = chat;

            newState = Object.assign({}, state);
            break;

        case CHAT_LAST_TYPED_MESSAGE_UPDATE:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });

            chat = state.chats[chatIndex];
            chat = Object.assign({}, chat);

            chat.lastTypedMessage = action.payload.message;

            state.chats[chatIndex] = chat;

            newState = Object.assign({}, state);
            break;

        case CHAT_DISPLAY_MODE_UPDATE:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            chat = state.chats[chatIndex];
            chat = Object.assign({}, chat);
            chat.displayMode = action.payload.displayMode;
            if (action.payload.displayMode === Constants.CHAT_WINDOW_STATE_NORMAL) {
                chat.unReadMessageCount = 0;
            }
            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state);
            break;

        // case CHAT_REMOVE:
        //     meetingId = action.payload.meetingId
        //     chatIndex = -1
        //     chat = state.chats.find((chat, i) => {
        //         if (chat.meetingId === meetingId) {
        //             chatIndex = i
        //             return true
        //         } else {
        //             return false
        //         }
        //     })

        //     if (!chat) {
        //         return state 
        //     }

        //     chats = [...state.chats] // clone
        //     chats.splice(chatIndex, 1)
        //     //chats[chat.meetingId] = chat
        //     newState = Object.assign({}, state, { chats })
        //     // break
        //     return newState

        case CHAT_ADD:
            chat = action.payload;
            chat.historyMessagesUrl = null;
            var isMeetingExist = state.chats.some(function (c) {
                return c.meetingId === chat.meetingId;
            });
            if (isMeetingExist) {
                return state; // no state modificaion required
            }

            chats = [].concat(_toConsumableArray(state.chats)); // clone
            chats.push(chat);
            //chats[chat.meetingId] = chat
            newState = Object.assign({}, state, { chats: chats });
            // break
            return newState;

        case CHAT_ADD_MESSAGE:

            console.log("chatreducer: Add msg: ", JSON.stringify(action.payload));
            /*
             - There are two ways chat_add_message will be triggered, 
                 1. when user entered message in chat box
                 2. when receive message from server
               - While receiving message it need to be checked for duplicate, if duplicate message it need to further
               check for delivery_status, since user who entered the message will also receive same message, in that
               case just need to replace message with updated delivery_status
               - In case of new message, just add as last message to the chat    
            */
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            var isMessageUpdate = false;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });

            var message = action.payload.message;
            if (action.payload.call_type === Constants.MESSAGE_CALL_TYPE_RECEIVE) {
                var messageIndex = -1;
                var duplicateMessage = chat.messages.find(function (msg, i) {
                    if (msg.message_id === message.message_id) {
                        messageIndex = i;
                        return true;
                    } else {
                        return false;
                    }
                });

                if (duplicateMessage) {
                    if (message.delivery_status === Constants.MESSAGE_DELIVERY_STATUS_INFLIGHT) {
                        message.delivery_status = Constants.MESSAGE_DELIVERY_STATUS_DELIVERED;
                        chat.messages[messageIndex] = message;
                        isMessageUpdate = true;
                    } else {
                        console.warn("duplicate message no state change required message id: " + duplicateMessage.message_id);
                        return state; // no state modification required
                    }
                }
            }

            chat = Object.assign({}, chat); // clone 

            //making typing message empty for that corresponding sender.
            if (chat.userTypingProperties && chat.userTypingProperties[action.payload.message.data.sender_id]) {
                chat.userTypingProperties[action.payload.message.data.sender_id].message = '';
            }

            var chatMode = chat.displayMode;
            var unreadmsgCount = chat.unReadMessageCount;
            if (chatMode === Constants.CHAT_WINDOW_STATE_MINIMIZED && action.payload.message.action === Constants.CHAT_ACTION_MESSAGE_NEW) {
                chat.unReadMessageCount = unreadmsgCount + 1;
            }

            console.log("ChatMode: ", chatMode, action.payload.message.action, chat.unReadMessageCount);

            if (!isMessageUpdate) {
                // let chatIndex = state.chats.findIndex((chat) => chat.meetingId === meetingId) 
                var messages = chat.messages;
                if (messages.count > MESSAGE_RETAIN_COUNT) {
                    messages.shift(0);
                }
                message.server_timestamp = message.server_timestamp ? message.server_timestamp : Helpers.getCurrentTimeStampInUnix();
                messages.push(message);
            }

            state.chats[chatIndex] = chat;

            newState = Object.assign({}, state); // TODO: state immutability not maintained properly
            break;

        case LOAD_HISTORY_MESSAGES_SUCCESS:

            meetingId = action.payload.meeting_id;
            if (action.payload.size === 0) {
                return state;
            }

            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            chat = Object.assign({}, chat);

            chat.historyMessagesUrl = action.payload.previous;

            var historyMessages = action.payload.data;
            historyMessages.slice(0).reverse().map(function (messageObject) {

                var message = messageObject;

                var duplicateMessage = chat.messages.find(function (msg, i) {
                    if (msg.message_id === message.message_id) {
                        return true;
                    } else {
                        return false;
                    }
                });

                if (duplicateMessage) {
                    return null;
                }

                var messages = chat.messages;
                // if (messages.count > MESSAGE_RETAIN_COUNT) {
                //     messages.shift(0)
                // }
                message.server_timestamp = message.server_timestamp ? message.server_timestamp : Helpers.getCurrentTimeStampInUnix();
                messages.unshift(message);
                return null;
            });

            //sort based on server_timestamp
            chat.messages.sort(function (a, b) {
                return a.server_timestamp - b.server_timestamp;
            });

            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state); // TODO: state immutability not maintained properly
            break;

        case LOAD_HISTORY_MESSAGES_FAIL:
            newState = state;
            break;

        case CHAT_SET_CURRENT_MEETING:
            currentMeeting = { id: action.payload.meetingId };
            newState = Object.assign({}, state, { currentMeeting: currentMeeting });
            break;

        case CHAT_USER_JOIN:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            if (chat) {
                var participants = [].concat(_toConsumableArray(chat.participants));
                participants.push(action.payload.user);
                chat.participants = participants;
            }

            chat = Object.assign({}, chat); // clone 
            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state); // TODO: state immutability not maintained properly
            break;

        case CHAT_USER_LEAVE:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            if (chat) {
                var _participants = [].concat(_toConsumableArray(chat.participants));
                var _user = action.payload.user;
                _participants = _participants.filter(function (u) {
                    return u.id !== _user.id;
                });
                chat.participants = _participants;
            }

            chat = Object.assign({}, chat); // clone 
            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state); // TODO: state immutability not maintained properly
            break;

        case CHAT_USER_STATUS_CHANGE:
            // chat.participants[user.id] = {id:123, status:"busy", online:true}
            newState = state;
            break;

        case CHAT_ADD_USER:
            var user = Object.assign({}, initialUserState, action.payload);
            newState = Object.assign({}, state, { user: user }); // TODO: state immutability not maintained properly
            break;

        case CHAT_ADD_PARTICIPANT:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            if (chat) {
                var _participants2 = [].concat(_toConsumableArray(chat.participants));
                var newParticipant = action.payload.message.data;
                var participant = _participants2.find(function (participant) {
                    if (participant.id === newParticipant.id) return true;else return false;
                });
                if (!participant) {
                    _participants2.push(newParticipant);
                }
                chat.participants = _participants2;
            }

            chat = Object.assign({}, chat); // clone 
            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state); // TODO: state immutability not maintained properly
            break;

        case CHAT_UPDATE_PARTICIPANT_LIST:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            if (chat) {
                var _participants3 = chat.participants ? [].concat(_toConsumableArray(chat.participants)) : [];
                _participants3 = action.payload.participant_list;
                chat.participants = _participants3;
            }

            chat = Object.assign({}, chat); // clone 
            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state); // TODO: state immutability not maintained properly
            break;

        case CHAT_UNREAD_MESSAGES:
            meetingId = action.payload.meetingId;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            // chatIndex = state.chats.map(function(chat) { return chat.meetingId; }).indexOf(action.payload)
            chat = state.chats[chatIndex];
            chat = Object.assign({}, chat);

            chat.unReadMessageCount = action.payload.unreadMessagecount;
            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state);
            break;

        case CHAT_ENDED:
            meetingId = action.payload;
            chatIndex = -1;
            chat = state.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatIndex = i;
                    return true;
                } else {
                    return false;
                }
            });
            chat = state.chats[chatIndex];
            chat = Object.assign({}, chat);
            chat.meetingEnded = true;
            state.chats[chatIndex] = chat;
            newState = Object.assign({}, state);
            break;

        default:
        //console.log(`Error: Unknown action "${action}"`)
    }
    return newState;
}

function meetingEnded(payload) {
    return {
        type: CHAT_ENDED,
        payload: payload
    };
}

function addUser(user) {
    return {
        type: CHAT_ADD_USER,
        payload: user
    };
}

function addParticipant(user) {
    return {
        type: CHAT_ADD_PARTICIPANT,
        payload: user
    };
}

function updateParticipant(users) {
    return {
        type: CHAT_UPDATE_PARTICIPANT_LIST,
        payload: users
    };
}

function setCurrentMeeting(meetingId) {
    return {
        type: CHAT_SET_CURRENT_MEETING,
        payload: { meetingId: meetingId }
    };
}

function addChatMessage(chatMessage) {
    return {
        type: CHAT_ADD_MESSAGE,
        payload: chatMessage
    };
}

function addChat(chat) {
    return {
        type: CHAT_ADD,
        payload: chat
    };
}

function removeChat(meetingId) {
    return {
        type: CHAT_REMOVE,
        payload: meetingId
    };
}

function userJoin(payload) {
    return {
        type: CHAT_USER_JOIN,
        payload: payload
    };
}

function userLeave(payload) {
    return {
        type: CHAT_USER_LEAVE,
        payload: payload
    };
}

function userStartTypingMessage(message) {
    return {
        type: CHAT_USER_START_TYPING,
        payload: message
    };
}

function updateDisplayMode(displayMode) {
    return {
        type: CHAT_DISPLAY_MODE_UPDATE,
        payload: displayMode
    };
}

function updateTypingMessage(data) {
    return {
        type: CHAT_TYPING_MESSAGE_UPDATE,
        payload: data
    };
}

function updateLastTypedMessage(data) {
    return {
        type: CHAT_LAST_TYPED_MESSAGE_UPDATE,
        payload: data
    };
}

function updateUnreadMessagecount(data) {
    return {
        type: CHAT_UNREAD_MESSAGES,
        payload: data
    };
}

function loadHistoryMessages(meetingId) {
    return function (dispatch, getState) {

        var chat = getState().chatState.chats.find(function (chat, i) {
            if (chat.meetingId === meetingId) {
                return chat;
            } else {
                return false;
            }
        });

        var historyMessagesUrl = chat.historyMessagesUrl ? chat.historyMessagesUrl : null;

        (0, _helpers.getChatConfig)().apiService.getMeetingHistoryMessages(meetingId, historyMessagesUrl).then(function (res) {
            res.status === "success" ? dispatch(loadHistoryMessagesSuccess(res)) : dispatch(loadHistoryMessagesFail(res));
        }).catch(function (err) {
            console.log(err);
        });
    };
}

function loadHistoryMessagesSuccess(payload) {
    return {
        type: LOAD_HISTORY_MESSAGES_SUCCESS,
        payload: payload
    };
}

function loadHistoryMessagesFail(payload) {
    return {
        type: LOAD_HISTORY_MESSAGES_FAIL,
        payload: payload
    };
}

function loadParticipants(meetingId) {
    return function (dispatch, getState) {
        (0, _helpers.getChatConfig)().apiService.getMeetingParticipants(meetingId).then(function (res) {

            res.meetingId = meetingId;
            res.participant_list = res.data;
            res.status === "success" ? dispatch(updateParticipant(res)) : console.log("failed to participants list for meeting ", meetingId);
        }).catch(function (err) {
            console.log(err);
        });
    };
}


// WEBPACK FOOTER //
// ../chat/lib/components/chatreducer.js